<template>
  <v-card max-width="97%" height="95%" elevation="0" class="mx-0 mt-3">
    <v-card-title>
      Users
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="users"
      :items-per-page="10"
      class="elevation-1"
    >
      <!-- Customizing the DataTable with avatar -->
      <template v-slot:[`item.avatar`]="{ item }">
        <v-avatar color="primary_whiten" size="38" class="avatar-style">
          <span class="white--text headline">{{ item.avatar }}</span>
        </v-avatar>
      </template>

      <!-- Customizing the DataTable with Drop down options -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary">
              <v-icon v-bind="attrs" v-on="on" class="ma-2">
                {{ item.actions[0] }}</v-icon
              >
            </v-btn>
          </template>
          <span>{{ addHint }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary">
              <v-icon v-bind="attrs" v-on="on" class="ma-2">
                {{ item.actions[1] }}</v-icon
              >
            </v-btn>
          </template>
          <span>{{ editHint }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary">
              <v-icon v-bind="attrs" v-on="on" class="ma-2">
                {{ item.actions[2] }}</v-icon
              >
            </v-btn>
          </template>
          <span>{{ deleteHint }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  name: "Users",
  async created() {
    await this.fetchTotalUsers();
  },
  computed: {
    ...mapFields("users", ["totalUsers"]),
  },
  data: () => ({
    search: "",
    action: "",
    editHint: "Edit user Role",
    addHint: "Add user role",
    deleteHint: "Remove User",
    displayActions: false,
    headers: [
      {
        text: "Avatar",
        align: "start",
        sortable: false,
        value: "avatar",
      },
      {
        text: "Name",
        align: "start",
        sortable: true,
        value: "name",
      },
      { text: "Phone", value: "phone" },
      { text: "Country", sortable: false, value: "country" },
      { text: "City", value: "city" },
      //action data deleted
    ],
    users: [],
  }),
  methods: {
    ...mapActions("users", ["fetchTotalUsers"]),
  },
  watch: {
    totalUsers: {
      immidate: true,
      handler(value) {
        if (value.length != 0) {
          value.map((user) => {
            this.users.push({
              avatar: "ET",
              name: user.name,
              phone: user.phone_number,
              country: user.country,
              city: user.city,
              //actions deleted
            });
          });
        }
      },
    },
  },
};
</script>